/**
 * FilterSummary - active-filter callout shown above the result tables.
 * Indigo card that separates the applied filters from the surrounding page.
 */
import { Badge } from '@/client/components/ui/badge';

interface FilterSummaryProps {
  clientID?: string;
  start?: string;
  end?: string;
  categoryName?: string | null;
}

export function FilterSummary({ clientID, start, end, categoryName }: FilterSummaryProps) {
  const range = start && end ? `${start} to ${end}` : '';

  return (
    <div className="rounded-lg border border-l-4 border-l-indigo-500 bg-indigo-50 p-4 shadow-sm dark:border-l-indigo-400 dark:bg-indigo-950/40">
      <div className="mb-3 text-xs font-semibold uppercase tracking-wide text-indigo-700 dark:text-indigo-300">
        Active Filters
      </div>
      <div className="grid grid-cols-[auto_1fr] items-center gap-x-6 gap-y-2 text-sm">
        <span className="text-muted-foreground">Client</span>
        <Badge variant="default" className="justify-self-start text-sm">{clientID}</Badge>
        <span className="text-muted-foreground">Range</span>
        <Badge variant="default" className="justify-self-start text-sm">{range}</Badge>
        {categoryName && (
          <>
            <span className="text-muted-foreground">Category</span>
            <Badge variant="default" className="justify-self-start text-sm">{categoryName}</Badge>
          </>
        )}
      </div>
    </div>
  );
}
